import * as d3 from "d3";

export default function Doughnut({
  x,
  y,
  innerRadius,
  outerRadius,
  value,
  color,
  secondColor = "#f8f8f8",
  cornerRadius,
  onMouseOver,
  onMouseMove,
  onMouseOut,
}: any) {
  const pie: (d: any) => any[] = d3
    .pie()
    .sort(null)
    .value((d: any) => d.value);

  const arcPie = d3
    .arc()
    .innerRadius(innerRadius)
    .outerRadius(outerRadius)
    .padRadius(outerRadius)
    .cornerRadius(cornerRadius);

  const pieData = [
    { value, color },
    { value: 100 - value, color: secondColor },
  ];

  const pieArcData = pie(pieData);

  return (
    <g
      transform={`translate(${x},${y})`}
      onMouseOver={onMouseOver}
      onMouseMove={onMouseMove}
      onMouseOut={onMouseOut}
    >
      {pieArcData.map((d: any, index) => (
        <path key={index} fill={d.data.color} d={`${arcPie(d)}`}></path>
      ))}
    </g>
  );
}
